import './FormTable.scss'
import React,{useState, useEffect} from 'react'
import {Table, Row, Col, message, Icon, Checkbox, Button, Pagination, Modal, Dropdown, Menu, Tooltip, Input} from 'antd'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { getItemsPromise, sendRemindersOnbPromise, deleteDeclarationsPromise } from '../../promises'
import {ModalIndexCardPage} from '../../components'
import {ModalPdfViewer} from '../../../../../InterestConflicts/components'
import { AdvancedTabsComponent } from '../../components';

const FormTable = ({areas, filtersSideBar}) => {

	const [isAdvancedSearchVisible, setIsAdvancedSearchVisible] = useState(null)
	const [rut, setRut] = useState(null)
	const [itemTable, setItemTable] = useState(null)
  	const { t } = useTranslation()
	const [items, setItems] = useState([])
	const [isItemsLoading, setIsItemsLoading] = useState(false)
	const [currentPage, setCurrentPage] = useState(1)
	const [itemsTotalNum, setItemsTotalNum] = useState(-1)
	const [enableReminders, setEnableReminders] = useState(false)
	const [chkAll, setChkAll] = useState(false);
	const itemsPerPage = 10
	const [filters, setFilters] = useState(filtersSideBar);
	const [advancedFilters, setAdvancedFilters] = useState({});
	const [formId, setFormId] = useState(null);
	const [confirm, setConfirm] = useState(null);
	const [option, setOption] = useState(null);
	const [pendientesCount, setPendientesCount] = useState(0);
	const [rechazadasCount, setRechazadasCount] = useState(0);
	const [autorizadasCount, setAutorizadasCount] = useState(0);
	const [evaluacionCount, setEvaluacionCount] = useState(0);
	const [sortField, setSortField] = useState(null);
	const [sortDirection, setSortDirection] = useState(null);
	const [selectedItem, setSelectedItem] = useState([]);

    // checkedList: defaultCheckedList,
    // indeterminate: true,
    // checkAll: false,


	useEffect(() => {
		const combinedFilters = { ...filtersSideBar, ...advancedFilters };
		setFilters(combinedFilters);
		handleSearch(1, combinedFilters, sortField, sortDirection);
	}, [filtersSideBar])

	useEffect(() =>{
		handlePaginationChange(1)
	},[rut])

	const handleSelectDeselectAll = (e) => {
		setChkAll(e.target.checked)
		setEnableReminders(e.target.checked)
		if(!e.target.checked){
			setSelectedItem([])
		}else{
			let itemsPerPage = [];
			items.map(i => itemsPerPage.push(i.id))
			setSelectedItem(itemsPerPage);
		}
	}

	const handleMenuClick = (e) => {
		const action = e.key;
		setOption(action);
		setConfirm(true);
	}

	const handlePaginationChange = async (value) => {
		handleSearch(value, filters, sortField, sortDirection)
	}

	const menu = (
		<Menu onClick={handleMenuClick}>
			<Menu.Item key="1">
				<Icon type="mail" /> {t("messages.aml.formTable.sendReminders")}
			</Menu.Item>
			<Menu.Item key="2">
				<Icon type="delete" /> {t("messages.aml.formTable.delete")}
			</Menu.Item>
		</Menu>
	);

	const handleSendReminder = () => {
		if(selectedItem.length > 0){
			sendRemindersOnbPromise('KYC', filters, selectedItem).then((response) =>{
				if(response.success){
					message.success(t("messages.aml.formTable.remindersSentSuccess"));
					setConfirm(false)
					setOption(null)
					handlePaginationChange(currentPage)
				}else{
					message.error(t('messages.aml.formTable.remindersSentError'))
				}
			})
			setConfirm(false);
		}else{
			message.error(t("messages.aml.formTable.noItemsSelected"))
		}
	}

	const handleDeletePendings = () => {
		if(selectedItem.length > 0){
			deleteDeclarationsPromise('KYC', filters, selectedItem).then((response) =>{
				if(response.success){
					message.success(t("messages.aml.formTable.formsDeleted"));
					setConfirm(false)
					setOption(null)
					handlePaginationChange(currentPage)
				}else{
					message.error(t('messages.aml.notifications.anErrorOcurred'))
				}
			})
			setConfirm(false);
		}else{
			message.error(t("messages.aml.formTable.noItemsSelected"))
		}
	}

	const handleSearch = async (page, filters, sorField=null, sortDirection=null) => {
		const fromNum = ((page - 1) * itemsPerPage)
		filters.from = fromNum;
		filters.size = itemsPerPage;
		//filters.category = categoria;
		filters.rutNombre = rut;
		filters.sorField = sorField;
		filters.sortDirection = sortDirection;
		setIsItemsLoading(true)
		const items = await getItemsPromise("KYC", filters)
		setItemsTotalNum(items.data.total)
		setItems(items.data.records)
		setChkAll(false);
		setSelectedItem([]);
		setPendientesCount(0)
		setEvaluacionCount(0)
		setRechazadasCount(0)
		setAutorizadasCount(0)

		if(items.data.filters && items.data.filters.status) {
			const pendientes = items.data.filters.status.filter(s => s.status === 'PENDIENTE')
			if(pendientes.length > 0) setPendientesCount(pendientes.reduce((acc, value) => {return acc+value.total},0))

			const evaluacion = items.data.filters.status.filter(s => s.status === 'EVALUACION')
			if(evaluacion.length > 0) setEvaluacionCount(evaluacion.reduce((acc, value) => {return acc+value.total},0))

			const rechazadas = items.data.filters.status.filter(s => s.status === 'RECHAZADA')
			if(rechazadas.length > 0) setRechazadasCount(rechazadas.reduce((acc, value) => {return acc+value.total},0))

			const autorizadas = items.data.filters.status.filter(s => s.status === 'AUTORIZADA')
			if(autorizadas.length > 0) setAutorizadasCount(autorizadas.reduce((acc, value) => {return acc+value.total},0))
		}

		setCurrentPage(page)
		setIsItemsLoading(false)
	}

	const cbFilters = (objFilters) => {
		// Combinar filtros avanzados con filtros laterales existentes
		setAdvancedFilters(objFilters);
		const combinedFilters = { ...filtersSideBar, ...objFilters };
		setFilters(combinedFilters);
		handleSearch(1, combinedFilters, sortField, sortDirection);
	};

	const handleCancel = () => {
		handleSearch(currentPage, filters, sortField, sortDirection)
		setItemTable(null);
	};

	const onCancelPdfViewer = () => {
			setFormId(null);
	}

	const changeTable = (pagination, filters, sorter, currentPageData) => {
		let sF = null
		let sD = null
		if(sorter.order) {
			sF = sorter.field
			sD = sorter.order === 'ascend' ? 'asc' : 'desc'
		}
		setSortField(sF)
		setSortDirection(sD)
		handleSearch(currentPage, filters, sF, sD)
		return false
	}

	const handlePdfViewer = (record) => {
		setFormId(record.id);
	}

	const handleShowIndexCard = (record) => {
		setItemTable(record)
	}

  const getTableColumns = () => {
		let columns = [
      {
				title: () => (
					<div>
						<Checkbox onChange={handleSelectDeselectAll} checked={chkAll} />
					</div>
				),
				width: 5,
				align: 'center',
				render: (text, record) => {
					if (record.statusDecl === 'PENDIENTE') {
						return <Checkbox
						checked={selectedItem.filter(i => i === record.id).length > 0}
						onChange={(e) => {
							setChkAll(false)
							let checkedItem = [...selectedItem]
							if(e.target.checked) {
								checkedItem.push(record.id)
							}else{
								checkedItem = checkedItem.filter(i => i !== record.id)
							}
							setSelectedItem(checkedItem)
							setEnableReminders(checkedItem.length > 0)
						}}
						/>
					}
				}
			},
			{
				title: t("messages.aml.formTable.column.nameRut"),
				width: 180,
				elipsis: true,
				dataIndex: 'name',
				render: ((name, record) => {
					return <>
					<div className="name-col-table">
						<Button type="link" onClick={ () => handleShowIndexCard(record) }>{record.name}</Button>
						<Button type="link" onClick={ () => handleShowIndexCard(record) }>{record.rut}</Button>
					</div>
					</>
				}),
				sorter: (a, b) => { return false }
			},
			{
				title: t("messages.aml.formTable.column.folio"),
				dataIndex: 'folio',
	            width: 130,
				sorter: (a, b) => { return false }
			},
			{
				title: t("messages.aml.formTable.column.request"),
				width: 90,
				dataIndex: 'sendDate',
				render: (text) => {
					return moment(text).format('DD/MM/YYYY')
				},
				sorter: (a, b) => { return false }
			},
			{
				title: t("messages.aml.formTable.column.completedDate"),
				width: 130,
				dataIndex: 'receiveDate',
				render: (receiveDate) => {
					return receiveDate ? moment(receiveDate).format('DD/MM/YYYY') : '---'
				},
				sorter: (a, b) => { return false }
			},
			{
				title: t("messages.aml.formTable.column.status"),
				width: 120,
				dataIndex: 'statusDecl',
				render: (text) => {
					return t("messages.aml.formKycStatus."+text)
				},
				sorter: (a, b) => { return false }
			},
			{
				title: t("messages.aml.formTable.column.statusDate"),
				width: 130,
				dataIndex: 'statusDate',
				render: (statusDate) => moment(statusDate).format('DD/MM/YYYY'),
				sorter: (a, b) => { return false }
			},
			{
				title: t("messages.aml.formTable.column.reminder"),
				width: 120,
				dataIndex: 'lastReminder',
				render: (lastReminder) => lastReminder ? moment(lastReminder).format('DD/MM/YYYY'): t("messages.aml.formTable.withoutReminder"),
				sorter: (a, b) => { return false }
			},
			{
				width: 80,
				render: ((record) => {
					return(
						<Row>
							<Col span={12}>
								<div>
									{ record.statusDecl !== 'PENDIENTE' &&
										<Icon type="file-pdf" className="file-pdf"
											  onClick={ () =>
											  handlePdfViewer(record) }
											  style={{fontSize: '20px'}}
										/>
									}
								</div>
							</Col>
							<Col span={12}>
								<div>
									{ record.statusDecl !== 'PENDIENTE' && record.files && record.files.length > 0 &&
										<Tooltip title={record.files.length + " " + t("messages.aml.formTable.attachedFiles")}>
											<Icon type="paper-clip"
												style={{fontSize: '20px'}}
											/>
										</Tooltip>
									}
								</div>
							</Col>
						</Row>
					)
				}
				)
			}
		]

		return columns
	}

    return (
        <div className="formTable-content">
					<Row>
						<Col span={3}>
							<div className="solicitudes-card">
								{t("messages.aml.formTable.pending")} <br/>
								{pendientesCount}
							</div>
						</Col>
						<Col span={3}>
							<div className="solicitudes-card">
								{t("messages.aml.formTable.completed")} <br/>
								{evaluacionCount}
							</div>
						</Col>
						<Col span={3}>
							<div className="solicitudes-card">
								{t("messages.aml.formTable.authorized")} <br/>
								{autorizadasCount}
							</div>
						</Col>
						<Col span={3}>
							<div className="solicitudes-card">
								{t("messages.aml.formTable.rejected")} <br/>
								{rechazadasCount}
							</div>
						</Col>
						<Col span={9} style={{paddingTop: 6}}>
							<Col span={19} offset={3}>
								<Input.Search
									placeholder={t("messages.aml.formTable.searchNameOrRut")}
									style={{ width: "100%", marginTop: "0px"}}
									onSearch={(value) => {setRut(value)}}
									allowClear
								/>
							</Col>
							<Col span={2}>
								<div className={isAdvancedSearchVisible ? 'advanced-search on' : 'advanced-search'} onClick={!isAdvancedSearchVisible ? () => {setIsAdvancedSearchVisible(true)} : () => {setIsAdvancedSearchVisible(false)}}>
									<Icon style={{fontSize: '20px', marginTop: 5, marginLeft: 10, cursor: 'pointer'}} type={!isAdvancedSearchVisible ? 'filter' : 'close'} />
								</div>
							</Col>
						</Col>
						<Col span={3}>
							<div className="action-button-form">
								<Dropdown overlay={menu} disabled={!enableReminders}>
									<Button style={{marginTop: 8}}>
										{t("messages.aml.action")} <Icon type="down" />
									</Button>
								</Dropdown>
							</div>
						</Col>
						<Modal
							title={option === "1" ? t("messages.aml.formTable.sendReminderToPending"):t("messages.aml.formTable.deletePending")}
							visible={confirm}
							onCancel={() => setConfirm(false)}
							okText={option === "1" ? t("messages.aml.formTable.send"):t("messages.aml.formTable.delete")}
							maskClosable={false}
							centered={true}
							footer={option==="1"?
							[<Button onClick={handleSendReminder} type="primary">{t("messages.aml.formTable.send")}</Button>]
							:
							[<Button onClick={handleDeletePendings} type="danger">{t("messages.aml.formTable.delete")}</Button>]
							}
							>
							<h3>{option === "1" ?
								t("messages.aml.formTable.wantToSendReminder")
								:
								t("messages.aml.formTable.wantToDeleteForms")}
							</h3>
						</Modal>
					</Row>
					<Row>
						<Col span={24}>
							<div className={isAdvancedSearchVisible === null ? 'filters-wrapper null' : (isAdvancedSearchVisible ? 'filters-wrapper show' : 'filters-wrapper hide')}>
								<div className="filters-wrapper-inner">
									<AdvancedTabsComponent cbFilters={cbFilters} areas={areas}/>
								</div>
							</div>
						</Col>
					</Row>
					<div className="table-req-onb">
						<Row>
							<Table size="small" pagination={false} columns={getTableColumns()} dataSource={items} onChange={changeTable} loading={isItemsLoading} />
						</Row>

						{formId &&
							<Modal
							className="modal-pdf-viewer"
							title={t("messages.aml.formTable.form")}
							centered={true}
							width={1000}
							header={null}
							footer={false}
							onCancel={onCancelPdfViewer}
							visible={true}
							><ModalPdfViewer
								pdfId={formId}
							/>
							</Modal>
						}
						<div className="pagination-formtable">
							<Row>
								{itemsTotalNum > 0 &&
									<Pagination
										onChange={handlePaginationChange} pageSize={itemsPerPage} current={currentPage} total={itemsTotalNum}
										showTotal={(total, range) =>
											t("messages.aml.pagination.recordsRange", {
												start: range[0],
												end: range[1],
												total,
											})
										}
									/>
								}
							</Row>
						</div>
					</div>

					{itemTable &&
						<Modal
							wrapClassName="modal-index-card"
							title={"Formulario OnBoarding de "+t("messages.aml.category."+itemTable.category)}
							visible={true}
							onCancel={handleCancel}
							cancelText={t("messages.aml.btnClose")}
							footer={null}
							width={1200}
							style={{top:"10px"}}
						>
							<ModalIndexCardPage item={itemTable} handleCancel={handleCancel}/>
						</Modal>
					}
        </div>
    )
}

export default FormTable
